import { computed } from 'vue';
import useExperimentIds from '@composables/useExperimentIds';

export const GOOGLE_AD_INLINE_3_EXPERIMENT = '2806-21';

export default function useGoogleAdInline3Experiment() {
  const { experimentIds } = useExperimentIds();
  const isGoogleAdInline3ExperimentEnabled = computed(() => experimentIds.value.includes(GOOGLE_AD_INLINE_3_EXPERIMENT));
  return {
    isGoogleAdInline3ExperimentEnabled,
  };
}
